import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { useTrans } from "../../../../hooks";
import ContestFormField from "../ContestFormField";
import { MAP_TARGET_AUDIENCES } from "../constants";
import { FormValidation } from "../FormValidation";
import { requiredField } from "../helpers";
import ErrorField from "./ErrorField";

const TargetAudienceField = ({
  form,
  disableForm,
  onFormChange,
  fieldStatus,
  submitted
}) => {
  const { trans } = useTrans();

  const title = trans("Target audience");

  const subtitle = (
    <div className="subtitle">
      {trans(
        "Please indicate if your story is geared towards young adults (13-18 year olds), new adults (18-25 year olds), or adults (those 25 years of age or older)."
      )}
    </div>
  );

  const errorCondition =
    (fieldStatus.fieldInvalid ||
      (fieldStatus.fieldName !== "targetAudience" &&
        fieldStatus.fieldName !== "" &&
        submitted)) &&
    form.targetAudience === "";

  return (
    <ContestFormField title={title} subtitle={subtitle}>
      <FormValidation validationRules={[requiredField(trans)]}>
        {({ ref, errorMessage, className }) => (
          <React.Fragment>
            <select
              ref={ref}
              id="target-audience-select"
              value={form.targetAudience}
              name="targetAudience"
              disabled={disableForm}
              className={classNames("form-element", className)}
              onChange={onFormChange}
              aria-label={trans("Select an option")}
            >
              <option value="" disabled>
                {trans("Select an option")}
              </option>
              {MAP_TARGET_AUDIENCES(trans).map(length => (
                <option key={length.key} value={length.key}>
                  {length.value}
                </option>
              ))}
            </select>
            <ErrorField
              errorMessage={errorMessage}
              errorCondition={errorCondition}
              fieldId={"target-audience"}
            />
          </React.Fragment>
        )}
      </FormValidation>
    </ContestFormField>
  );
};

TargetAudienceField.propTypes = {
  form: PropTypes.object.isRequired,
  disableForm: PropTypes.bool.isRequired,
  onFormChange: PropTypes.func.isRequired,
  fieldStatus: PropTypes.shape({
    fieldInvalid: PropTypes.bool,
    fieldName: PropTypes.string
  }).isRequired,
  submitted: PropTypes.bool.isRequired
};

export default TargetAudienceField;
